import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { plainToClass } from 'class-transformer';
import { SelectItem } from 'primeng/api';

import { CommonTransformationService, Format, EnumType, CommonDataService, DialogStyle40 } from '@app/shared';

import { FeedbackPost, FeedbackSubject, Subject } from './suggestion-management';
import { SuggestionManagementDataService } from './suggestion-management-data.service';
import { UserService } from '@app/core';

@Component({
  selector: 'app-suggestion-management',
  templateUrl: './suggestion-management.component.html',
  styleUrls: ['./suggestion-management.component.css'],
  providers: [SuggestionManagementDataService]
})

export class SuggestionManagementComponent implements OnInit {

  DialogStyle40 = DialogStyle40;

  Format: typeof Format = Format;

  @ViewChild('betaForm') betaForm: NgForm;

  category: string;                        // select category
  subjectDialog: boolean = false;          // dialog for adding subject name

  feedbackSubject: FeedbackSubject;        // object modeled for adding subject
  feedbackPost: FeedbackPost;              // object modeled for adding post
  feedbackPosts: FeedbackPost[];           // has list of posts based on category and subject


  subject: Subject;                        // object modeled for searchable subject
  subjectDropdown: SelectItem[] = [];      // has list of subjects based on search query
  categoryDropdown: SelectItem[] = [];     // has list of categories ENUM


  constructor (private dataservice: SuggestionManagementDataService, private user: UserService, private transform: CommonTransformationService, private commonDataService: CommonDataService) {
  }

  ngOnInit() {
    this.feedbackPost = new FeedbackPost();
    this.subject = new Subject();
    this.getCategory();

  }

  /**
   * @desc retrieves list of categories form backend
   */
  getCategory() {
    this.commonDataService.getEnumPairAsDropdown(EnumType.FeedBackCategories).subscribe(res => {
      this.categoryDropdown = res;
    });
  }

  /**
   * @desc retrieves list from backed based on category selected
   * @param category selected category
   */
  onCategorySelect(category: string) {
    if (category) {
      this.subject = new Subject();
      this.subjectDropdown = [];
      this.feedbackPosts = [];
      this.dataservice.getSubjects(category).subscribe(res => {
        this.subjectDropdown = this.transform.convertToDropDown("name", res.list, "id");
      });
    }
  }


  /**
   * @desc on selected subject, retrieves all the posts related to it
   * @param subject : selected subject
   * @param category : selected category
   */
  onSubjectSelected(subject: Subject, category: string) {
    this.dataservice.getPostBySubjectIdAndCategory(subject.id, category).subscribe(res => {
      this.feedbackPosts = plainToClass(FeedbackPost, res.list);
    });
  }

  /**
   * @desc dialog opens in add mode to add new subject
   */
  showAddSubject() {
    this.feedbackSubject = new FeedbackSubject();
    this.feedbackPosts = [];
    this.subjectDialog = true;
  }

  /**
   * @desc saves new subject for the selected category to db
   * @param subject : input text
   * @param category : selected category
   */
  saveSubject(subject: FeedbackSubject, category: string) {
    subject.feedbackCategory = category;
    this.dataservice.saveSubject(subject).subscribe(res => {
      this.dataservice.getSubjects(category).subscribe(res => {
        this.subjectDropdown = this.transform.convertToDropDown("name", res.list, "id");
        if (res.list.length > 0) {
          const item = res.list.find(i => i.name === subject.subject);
          this.subject.id = item.id;
        }
      });
      this.subjectDialog = false;
    });
  }

  /**
   * @desc saves post for that subject to db
   * @param feedbackPost new post
   * @param subject selected subject
   */
  savePost(feedbackPost: FeedbackPost, subject: Subject) {
    feedbackPost.feedbackSubjectId = subject.id;
    this.dataservice.savePost(feedbackPost).subscribe(res => {
      res.userFullName = this.user.info.fullName;
      res.createdOn = new Date();
      this.feedbackPosts.unshift(plainToClass(FeedbackPost, res as FeedbackPost));
      this.feedbackPost = new FeedbackPost();
      this.betaForm.reset();
    });
  }

}
